import { defineMessages } from 'react-intl';

export default defineMessages({
  status: {
    description: 'Filter option for Return Status',
    defaultMessage: 'Status',
    id: 'ZbJULm',
  },
  returnDate: {
    description: 'Filter option for Return Date',
    defaultMessage: 'Return Date',
    id: 'Hli4ND',
  },
  createDate: {
    description: 'Filter option for Create Date',
    defaultMessage: 'Create Date',
    id: 'IyhYbi',
  },
  approvalType: {
    description: 'Filter option for Approval Type',
    defaultMessage: 'Approval Type',
    id: 'RVThZg',
  },
  returnExchangeType: {
    description: 'Filter option for the type of the return requests',
    defaultMessage: 'Request Type',
    id: 'VdnodB',
  },
  paymentType: {
    description: 'Filter option for Refund Method',
    defaultMessage: 'Refund Method',
    id: 'HlEUQX',
  },
  fulfillmentStatuses: {
    description: 'Filter option for Shipment Status',
    defaultMessage: 'Shipment Status',
    id: 'ZS0T0t',
  },
  lockedRequest: {
    description: 'Filter option for Locked Status',
    defaultMessage: 'Locked Status',
    id: 'Ulsmx/',
  },
  amount: {
    description: 'Filter option for Amount',
    defaultMessage: 'Amount',
    id: 'hLnT+7',
  },
  store: {
    description: 'Filter option for Store',
    defaultMessage: 'Store',
    id: 'vLp1v1',
  },
  multipleStores: {
    description: 'Label for multiple store filters selected',
    defaultMessage: '(Multiple Stores)',
    id: 'zkG6Lf',
  },
  // TODO: delete/cleanup some of these
  multipleStatuses: {
    description: 'Label for multiple status filters selected',
    defaultMessage: '(Multiple Statuses)',
    id: 'xa1H5S',
  },
  multipleReturnExchangeTypes: {
    description: 'Label for multiple return request type filters selected',
    defaultMessage: '(Multiple Request Types)',
    id: 'CNLr4U',
  },
  multipleReturnShipmentStatuses: {
    description: 'Label for multiple return shipment status filters selected',
    defaultMessage: '(Multiple Shipment Statuses)',
    id: '8pTw2g',
  },
});

export const StatusMessages = defineMessages({
  cancelled: {
    description: 'Status filter option for Order Service Cancelled',
    defaultMessage: 'Cancelled',
    id: 'qsLcBV',
  },
  processed: {
    description: 'Status filter option for Processed',
    defaultMessage: 'Processed',
    id: 'MrCwu5',
  },
});

export const ApprovalTypeMessages = defineMessages({
  manual: {
    description: 'Approval Type filter option for Manual approval',
    defaultMessage: 'Manual',
    id: 'ZDJIb2',
  },
  eventBased: {
    description: 'Approval Type filter option for Event Based approval',
    defaultMessage: 'Event Based',
    id: 'RzIZGT',
  },
});

export const RequestLineItemTypeMessages = defineMessages({
  return: {
    description: 'Request Line Item Type filter option for Return',
    defaultMessage: 'Return',
    id: 'F7/yTw',
  },
  exchange: {
    description: 'Request Line Item Type filter option for Exchange',
    defaultMessage: 'Exchange',
    id: 'Z0yhSs',
  },
  purchase: {
    description: 'Request Line Item Type filter option for Purchase',
    defaultMessage: 'Purchase',
    id: '6CArRb',
  },
});

export const PaymentTypeMessages = defineMessages({
  giftCard: {
    description: 'Payment Type filter option for Gift Card',
    defaultMessage: 'Gift Card',
    id: 'IFjtX/',
  },
  originalPaymentMethod: {
    description: 'Payment Type filter option for Original Payment Method',
    defaultMessage: 'Original Payment Method',
    id: '1aQuBs',
  },
});

export const ReturnShipmentStatusMessages = defineMessages({
  delivered: {
    description: 'Return Shipment Status filter option for Delivered',
    defaultMessage: 'Delivered',
    id: 'Q2+F3Z',
  },
  inTransit: {
    description: 'Return Shipment Status filter option for In-Transit',
    defaultMessage: 'In-Transit',
    id: 'OlW0o/',
  },
  preTransit: {
    description: 'Return Shipment Status filter option for Pre-Transit',
    defaultMessage: 'Pre-Transit',
    id: 'x0TZvq',
  },
});
